<div class="users-admin-container">
  <!-- Componente de Filtros -->
  <app-user-filters
    [filters]="filters"
    [roles]="roles"
    [statuses]="statuses"
    [companies]="companies"
    (searchChange)="onSearchChange($event)"
    (roleChange)="onRoleChange($event)"
    (statusChange)="onStatusChange($event)"
    (companyChange)="onCompanyChange($event)"
    (clearFilters)="onClearFilters()"
    (createUser)="onCreateUser()"
  ></app-user-filters>

  <!-- Componente de Tabela -->
  <app-users-table
    [dataSource]="dataSource"
    [isLoading]="isLoading"
    [length]="totalItems"
    [config]="tableConfig"
    [actions]="tableActions"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
  ></app-users-table>
</div>
